<template>
  <div class="inquiry-detail">
    <!-- title -->
    <my-title
      v-if="code"
      :code="code"
      :crumb="showCrumb"
    >
      <!-- <template>
        <div
          v-if="permissionInfo"
          class="btns"
        >
          <a-button
            v-if="permissionInfo && permissionInfo.is_show_archive"
            @click="handleArchive"
          >
            {{ $t('message["417"]') }}
          </a-button>
          <a-button
            v-if="permissionInfo.is_show_apply"
            @click="handleApply"
          >
            {{ $t('message["1621"]') }}
          </a-button>
          <a-button
            v-if="showPassTab && permissionInfo && permissionInfo.is_show_del"
            type="danger"
            @click="handleDelete"
          >
            {{ $t('message["962"]') }}
          </a-button>
        </div>
      </template> -->
    </my-title>
    <div
      v-if="!loading && Object.keys(detailData).length > 0"
      class="content"
    >
      <!-- 待审核和已拒审的询盘详情 -->
      <my-tab
        v-if="!showPassTab"
        :type="type"
        :form-data="formData"
        :reject-data="detailData.audit_info || {}"
      />

      <!-- 审核通过的询盘详情 -->
      <!-- <my-tab2
        v-else
        :form-data="formData"
        :detail-data="detailData"
      /> -->
    </div>
    <div
      v-else-if="!loading && Object.keys(detailData).length === 0"
      class="spin-fixed-center no_data"
    >
      <p><i class="iconfont iconicon-test38 logo" /></p>
      <p>
        {{ $t('message["343"]') }}
      </p>
    </div>
    <a-spin
      v-else
      class="spin-fixed-center"
    />
    <!-- 申请重新分配弹窗 -->
    <!-- <apply-modal
      :visible.sync="showApplyModal"
      :inquiry-id="inquiryId"
    /> -->
    <gallery />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { fixed } from '@/lib/directives'
import MyTab from './Tabs'
// import MyTab2 from './Tabs2'
import MyTitle from '@/components/pc/Title'
// import ApplyModal from './modal/ApplyModal'
import Gallery from '@/components/pc/Gallery'
import eventBus from '@/lib/eventBus'
import { setReplyPositionQuery } from '@/lib/before-router'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    MyTab,
    // MyTab2,
    MyTitle,
    // ApplyModal,
    Gallery
  },
  directives: { fixed },
  data () {
    return {
      showApplyModal: false,
      showCrumb: true
    }
  },
  beforeRouteEnter (to, from, next) {
    const { page } = to.query
    next(vm => {
      if (page === FROM_SOPURCE) {
        vm.showCrumb = false
      }
    })
  },
  computed: {
    ...mapState(['menuDatas']),
    ...mapState('inquery/detailData', [
      'loading',
      'detailData'
    ]),
    ...mapGetters('inquery/detailData', [
      'formData',
      'permissionInfo'
    ]),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    code () {
      return (this.detailData && this.detailData.info && this.detailData.info.code) || ''
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    auditStatus () {
      const { info = {} } = this.detailData
      const { audit_status: auditStatus } = info
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) {
          flag = true
        }
      }
      return flag
    }
  },
  watch: {
    $route: {
      handler: async function (val, oldVal) {
        const { inquiryId: newInquiryId } = val.params
        const { inquiryId: oldInquiryId } = oldVal.params

        newInquiryId !== oldInquiryId && await this.getDetail()
      },
      // 深度观察监听
      deep: true
    }
  },
  async created () {
    await this.getDetail()
    // 清空关联人员列表
    this.SET_RELATE_LIST_DATA([])
    eventBus.$on('fetchInquiryDetail', this.getDetail)
  },
  beforeDestroy () {
    eventBus.$off('fetchInquiryDetail', this.getDetail)
  },
  destroyed () {
    this.UPDATA_DETAIL({})
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapActions('inquery/detailData', ['fetchDetail', 'deleteDetail', 'archiveInquiry']),
    ...mapMutations('inquery/detailData', ['UPDATA_DETAIL', 'SET_LOADING']),
    ...mapMutations('inquery/relateData', ['SET_RELATE_LIST_DATA']),
    async getDetail (inquiryId) {
      const chain = await this.fetchDetail()
      chain
        .params({
          inquiryid: inquiryId || this.inquiryId,
          scope: this.from,
          checkrepeatfieldkey: this.checkrepeatfieldkey
        })
        .onNetSuccess((res = {}) => {
          this.setDocumentTitle(res)
          this.redirectRouter()
        })
        .onFail((e, error) => {
          this.SET_LOADING(false)
        })
        .fetch()
    },
    async setDocumentTitle (res) {
      let projectname, comname
      let { baseinfo = {} } = res.data || {}
      comname = baseinfo.comname
      projectname = baseinfo.projectname

      const chain = await this.permissionMenu()
      chain.onSuccess(payload => {
        const { permissionMenuList = {} } = this.menuDatas
        let parent = {}
        if (this.from === 'my') {
          parent = permissionMenuList['inquiry-mine']
        } else if (this.from === 'all') {
          parent = permissionMenuList['inquiry-all']
        } else if (this.from === 'audit') {
          parent = permissionMenuList['inquiry-audit']
        }
        let { child = {} } = parent || {}
        let { name = '' } = (child && child[this.type]) || {}

        if (this.from === 'notice') {
          name = '通知'
        } else if (this.from === 'webhook') {
          name = '推送记录'
        } else if (this.from === 'clue') {
          name = '线索'
        }

        document.title = name + '-' + projectname + '-' + comname
      })
    },

    redirectRouter () {
      const noticeQuery = setReplyPositionQuery()
      let routerName = ''
      // 如果 pc 打开移动端发送的 InqueryDetail 链接
      if ((this.auditStatus === 0 || this.auditStatus === -1) && this.$route.name === 'InqueryPassDetail') {
        routerName = 'InqueryDetail'
      } else if (this.auditStatus === 1 && (this.$route.name === 'InqueryDetail')) {
        routerName = 'InqueryPassDetail'
      }
      if (noticeQuery) {
        this.$router.push({ ...this.$route, name: routerName, query: noticeQuery })
      } else {
        this.$router.push({ ...this.$route, name: routerName })
      }
    }

    /* successBackRoute () {
      let name = ''
      if (this.from === 'audit') {
        name = 'InqueryAudit'
      } else if (this.from === 'checkrepeat') {
        name = 'InqueryRepeat'
      } else {
        name = 'InqueryList'
      }
      if (this.from === FROM_SOPURCE) { // 从通知消息跳转到的详情页
        this.$router.push({ name: 'recordNotice' })
      } else {
        this.$router.push({
          name,
          query: {
            type: this.type,
            from: this.from
          }
        })
      }
    },
    handleArchive () {
      this.$confirm({
        title: this.$t('message["418"]'),
        content: this.$t('message["419"]') + '？',
        okText: this.$t('message["915"]'),
        okType: 'danger',
        cancelText: this.$t('message["896"]'),
        onOk: async () => {
          const chain = await this.archiveInquiry()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                this.successBackRoute()
              }
            })
            .params({
              inquiryid: this.inquiryId
            })
            .fetch()
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    },
    handleApply () {
      this.showApplyModal = true
    },
    handleDelete () {
      this.$confirm({
        title: this.$t('message["493"]'),
        content: this.$t('message["969"]') + '？',
        okText: this.$t('message["915"]'),
        okType: 'danger',
        cancelText: this.$t('message["896"]'),
        onOk: async () => {
          const chain = await this.deleteDetail()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                this.successBackRoute()
              }
            })
            .params({
              inquiryid: this.inquiryId
            })
            .fetch()
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    } */
  }
}
</script>

<style lang="scss" scoped>
.inquiry-detail::v-deep {
  padding-top: 16px;
  .btns {
    position: absolute;
    right: 0;
    bottom: 12px;
    .ant-btn-danger {
      margin-right: 0;
    }
  }
  .ant-form-item-label {
    white-space: normal;
  }
}
.no_data {
  width: 1040px;
  margin-top: 40px;
  .logo {
    font-size: 24px;
  }
  p {
    text-align: center;
    height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(179, 179, 179, 1);
    line-height: 24px;
    margin-bottom: 8px;
  }
}
</style>
